import { Component, Input } from '@angular/core';
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { ComparisonType, GameObject, RankingByLogin, TooltipType } from '../game.models';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';

@Component({
    selector: "cxone-game-qualifier",
    templateUrl: "./cxone-game-qualifier.component.html",
    styleUrl: "./cxone-game-qualifier.component.scss",
})
export class CxoneGameQualifierComponent {
    @Input() game: GameObject;
    @Input() gameStatus: string;
    @Input() ranking: RankingByLogin;
    @Input() checkTextTruncation: (
        tooltip: string,
        type: TooltipType
    ) => string;

    ComparisonType = ComparisonType;
    TooltipType = TooltipType;
    gs = null;

    constructor(
        public cvLocalizationService: CVLocalizationService,
        public metricFormatter: GenericMetricFormatterPipe,
        private gamesService: GamesService
    ) {
        this.gs = this.gamesService;
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "Games",
            key,
            defaultValue
        );
        return baseString;
    }

    getFormattedData(value, conversionType): string {
        return this.metricFormatter.transform(value, conversionType);
    }

    isQualifiedBetweenLabel(type: "left" | "right", showRight = false): string {
        if (
            this.game?.Qualifier == null ||
            this.game == null ||
            (this.ranking == null && this.gameStatus !== "Upcoming")
        )
            return "";

        const { leftNumber, rightNumber } = this.game?.QualifierLevels;
        let conversionType = this.game?.Qualifier?.conversionType;
        let convertedLeftNumber = this.getFormattedData(
            leftNumber,
            conversionType
        );
        let convertedRightNumber = this.getFormattedData(
            rightNumber,
            conversionType
        );

        if (leftNumber !== undefined && rightNumber !== undefined) {
            const minNumber = Math.min(leftNumber, rightNumber);
            const maxNumber = Math.max(leftNumber, rightNumber);
            if (showRight) {
                return type === "left"
                    ? `> ${this.getFormattedData(minNumber, conversionType)}`
                    : `> ${this.getFormattedData(maxNumber, conversionType)}`;
            }
            return type === "left"
                ? `${this.getFormattedData(minNumber, conversionType)} <`
                : `< ${this.getFormattedData(maxNumber, conversionType)}`;
        }
        return type === "left"
            ? `${convertedLeftNumber} <`
            : `< ${convertedRightNumber ?? convertedLeftNumber}`;
    }
}

